/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Geliver_Tracking_Resync_ErrorInputs */

const tr_geliver_tracking_resync_error = /** @type {(inputs: Geliver_Tracking_Resync_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yenileme hatası: ${i?.message}`)
};

const en_geliver_tracking_resync_error = /** @type {(inputs: Geliver_Tracking_Resync_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Refresh error: ${i?.message}`)
};

const de_geliver_tracking_resync_error = /** @type {(inputs: Geliver_Tracking_Resync_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisierungsfehler: ${i?.message}`)
};

const ru_geliver_tracking_resync_error = /** @type {(inputs: Geliver_Tracking_Resync_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка обновления: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Refresh error: {message}" |
*
* @param {Geliver_Tracking_Resync_ErrorInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_resync_error = /** @type {((inputs: Geliver_Tracking_Resync_ErrorInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Resync_ErrorInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_resync_error(inputs)
	if (locale === "de") return de_geliver_tracking_resync_error(inputs)
	if (locale === "ru") return ru_geliver_tracking_resync_error(inputs)
	return tr_geliver_tracking_resync_error(inputs)
});